import _ from 'lodash'

import i18n from 'modules/core/lib/i18n'
import { Model } from 'modules/core/lib/mobx-rest'
import { matchText } from 'modules/core/lib/stringUtils'

interface IField {
  [key: string]: any
  category_description?: string
  subcategory_description?: string
  description?: string
  enabled?: boolean
  relatable?: boolean
  supported_editors?: string[]
  path?: string
  is_identifier?: boolean
  label?: string
  category_label?: string
  subcategory_label?: string
  has_deprecated_path?: boolean
  table?: string
}

class Field extends Model<IField> {
  static isRootSubcategory(label: string): boolean {
    return label === 'root'
  }

  static isDeprecatedSubcategory(label: string): boolean {
    const deprecatedSubcategory = i18n.t('custom_reports.questions_configuration')

    return label === deprecatedSubcategory
  }

  get primaryKey(): string {
    return 'path'
  }

  static urlRoot() {
    return '/api/rest/reports/attributes'
  }

  get relatable(): boolean {
    return this.attributes.relatable ?? false
  }

  get isSqlBuilder(): boolean {
    return this.supportedEditors.includes('query_builder')
  }

  get supportedEditors(): Array<string> {
    return this.attributes.supported_editors ?? []
  }

  get table(): string {
    return this.attributes.path?.split('.')[0] ?? ''
  }

  get isIdentifier(): boolean {
    return this.attributes.is_identifier ?? false
  }

  matchFieldLabel(search: string): boolean {
    if (this.attributes.has_deprecated_path) return false

    return matchText(search, this.attributes.label ?? '')
  }

  matchCategoryLabel(search: string): boolean {
    if (this.attributes.has_deprecated_path) return false

    if (_.isNil(this.attributes.category_label)) return false

    return matchText(search, this.attributes.category_label)
  }

  matchSubCategoryLabel(search: string): boolean {
    if (this.attributes.has_deprecated_path) return false

    if (_.isNil(this.attributes.subcategory_label)) return false

    return matchText(search, this.attributes.subcategory_label)
  }

  /**
   * Check if search term match field label or category
   * label or subcategory label
   */
  matchLabels(search: string): boolean {
    return (
      this.matchFieldLabel(search) ||
      this.matchCategoryLabel(search) ||
      this.matchSubCategoryLabel(search)
    )
  }
}

export default Field
